import {RequestService} from '../RequestService/RequestService';

export async function injectTagManager() {
  let url = '/en/?type=1502888797';
  let userType = sessionStorage.getItem('dataLayer__userType') || 'defaultUserType';
  let gaProperty = sessionStorage.getItem('dataLayer__gaProperty') || 'defaultGaProperty';
  const resultData = await new RequestService().getRequestJson(url, null);
  if (gaProperty === 'defaultGaProperty') {
    gaProperty = resultData.gaProperty;
    sessionStorage.setItem('dataLayer__gaProperty', gaProperty);
  } else if (gaProperty !== resultData.gaProperty) {
    gaProperty = resultData.gaProperty;
    sessionStorage.setItem('dataLayer__userType', gaProperty);
  }
  if (userType === 'defaultUserType') {
    userType = resultData.userType;
    sessionStorage.setItem('dataLayer__userType', userType);
  } else if (userType !== resultData.userType) {
    userType = resultData.userType;
    sessionStorage.setItem('dataLayer__userType', userType);
  }

  (<any>window).dataLayer = (<any>window).dataLayer || [];
  (<any>window).dataLayer.push({
    'userType': userType,
  });

  /* tslint:disable */
  (<any>window).dataLayer = (<any>window).dataLayer || [];

  function gtag() {
    // @ts-ignore
    dataLayer.push(arguments);
  }

// @ts-ignore
  gtag('consent', 'default', {
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    ad_storage: 'denied',
    analytics_storage: 'denied',
    wait_for_update: 2000, // milliseconds to wait for update
  });
// @ts-ignore
  gtag('set', 'ads_data_redaction', true);

  // Google Tag Manager
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    // @ts-ignore
    j.async = true;
    // @ts-ignore
    j.src =
      'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    // @ts-ignore
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', gaProperty);
  /* tslint:enable */
}
